<sh-page id="login-failed-page-1" [theme]="theme">
    <sh-splash-screen id="login-failed-splash-screen-2" modal [attr.label]="'loginFailed.splash.label' | transloco" [attr.version]="'loginFailed.splash.version' | transloco">
        <sh-empty-state id="login-failed-empty-state-error"
            [attr.header]="'loginFailed.header' | transloco"
            [attr.label]="'loginFailed.message' | transloco"
            icon="error"
            icon-color="grey"
        ></sh-empty-state>
        <sh-button id="login-failed-button-retry" style="margin-top: 24px" [attr.label]="'loginFailed.button.retry' | transloco" (click)="onLoginClick()"></sh-button>
        <sh-text id="login-failed-text-5" slot="info" size="body-2" color="secondary">{{ 'loginFailed.copyright' | transloco }}</sh-text>
    </sh-splash-screen>
</sh-page>